import { GX_FAILURE, GX_NEUTRAL, GX_SUCCESS } from '@/config/colors';

export const getDiffColor = (value: number | null) => {
  if (!value) return GX_NEUTRAL;
  if (value === 0) return GX_NEUTRAL;
  return Math.sign(value) > 0 ? GX_SUCCESS : GX_FAILURE;
};
